import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGuitar } from '@fortawesome/free-solid-svg-icons/faGuitar';
import type { IconProps } from '../../types';

export function GuitarIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Guitar',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faGuitar}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
